import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    //예금해지 예상조회
    depositTermi: {
      acnoAls: "",
      expectation: {},
    },
    depositTermiRes: {}, // 예금갱신본거래 결과
    RBF0406H40: {}, //예금갱신예비 결과
    RBF0404B40: {}, //예금계좌상세조회 결과
    acnoValue: "", //해지예상조회시 계좌정보 저장
    selectedAcnoValue: "",
  };
};

const termiUpdat = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getSelectAcnInfo: state => {
      return acno => {
        const acnoList = state.accountList.outItem.dataGrid2.filter(v => v.acno === acno);
        return acnoList.length === 0 ? {} : _.first(acnoList);
      };
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default termiUpdat;
